import { each, assign, isArray } from 'lodash'

export default {
  watch: {
    $route: {
      handler () {
        this.__initialize()
      },
      immediate: true
    },

    queryParams () {
      this.__updateQueryStringFilters()
    },

    filters: {
      handler: '__buildQueryParams',
      immediate: true,
      deep: true
    }
  },

  data () {
    return {
      queryParams: {},
      __initialized: false
    }
  },

  methods: {
    __initialize () {
      if (this.filters === null || this.filters === undefined) {
        throw new Error('Component using "applies-filters" mixin without defining "filters" data prop.')
      }

      if (!this.__initialized) {
        this.filters = this.$options.data().filters
      }

      for (const filter in this.filters) {
        if (
          this.$route.query[filter] !== null &&
          this.$route.query[filter] !== undefined
        ) {
          if (isArray(this.filters[filter]) && !isArray(this.$route.query[filter])) {
            this.filters[filter] = [this.$route.query[filter]]
          } else {
            this.filters[filter] = this.$route.query[filter]
          }
        }
      }

      if (!this.__initialized) {
        this.__buildQueryParams()
      }

      this.__initialized = true
    },

    __buildQueryParams () {
      const queryParams = {}

      each(this.filters, (value, key) => {
        if (value !== null && value !== undefined) {
          queryParams[key] = value
        }
      })

      this.queryParams = queryParams
    },

    __updateQueryStringFilters (replace = true) {
      const query = assign({}, this.$route.query)

      for (const filter in this.filters) {
        if (this.filters[filter]) {
          query[filter] = this.filters[filter]
        } else {
          delete query[filter]
        }
      }

      this.$router[replace ? 'replace' : 'push']({ query, params: { __filters: true } }).catch(() => {})
    },

    applyQueryFilters () {
      this.__updateQueryStringFilters()

      return Promise.resolve()
    }
  }
}
